/* BEGIN TFX_COUT_JOUR
   Objectif : la ligne « soit X €/jour » des cartes de durée (snippets/tfx-cout-jour.liquid)
   affiche le coût de l'achat unique ou celui de l'abonnement Appstle selon l'option choisie.
   Montants calculés côté serveur (data-one / data-sub) : ce script ne fait que choisir le texte.
   Abonnement détecté comme dans assets/tfx-abo-qty.js : input[name="selling_plan"]:checked avec une valeur.
   Plan retenu : data-plan (carte liée à une durée), sinon plan sélectionné dans Appstle.
   Rollback : supprimer ce fichier et le snippet tfx-cout-jour (+ ses render).
*/
(function () {
  'use strict';
  if (window.__tfxCoutJourInstalled) return;
  window.__tfxCoutJourInstalled = true;

  function subPlanId(scope) {
    var checked = scope.querySelector('input[name="selling_plan"]:checked');
    return checked && checked.value ? checked.value : '';
  }

  function selectedPlanId(scope) {
    var select = scope.querySelector('select.appstle_select');
    return select && select.value ? select.value : '';
  }

  function refresh() {
    document.querySelectorAll('[data-tfx-day]').forEach(function (el) {
      var scope = el.closest('.js-product') || document;
      var amount = el.getAttribute('data-one') || '';
      var checkedPlan = subPlanId(scope);
      if (checkedPlan) {
        var map = {};
        try { map = JSON.parse(el.getAttribute('data-sub') || '{}'); } catch (e) { map = {}; }
        var id = el.getAttribute('data-plan') || selectedPlanId(scope) || checkedPlan;
        if (map[id]) amount = map[id];
      }
      var text = (el.getAttribute('data-tpl') || '[x]').replace('[x]', amount);
      if (el.textContent !== text) el.textContent = text;
    });
  }

  var timer = 0;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 80);
  }

  // Appstle ne propage pas toujours `change` sur ses radios : on écoute aussi le clic sur son widget.
  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (t && t.matches && (t.matches('input[name="selling_plan"]') || t.matches('select.appstle_select'))) schedule();
  });
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (t && t.closest && t.closest('.appstle_subscription_wrapper, [data-tfx-abo-qty]')) schedule();
  });
  // Cartes re-rendues au changement de variante (assets/variant-picker.js) ou dans l'éditeur.
  document.addEventListener('on:variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);

  // Le widget Appstle se charge après la page : premier alignement dès qu'il apparaît.
  var tries = 0;
  (function waitWidget() {
    if (document.querySelector('input[name="selling_plan"]') || tries > 40) { refresh(); return; }
    tries += 1;
    window.setTimeout(waitWidget, 250);
  })();
})();
/* END TFX_COUT_JOUR */
